export default "__VITE_ASSET__CnA8xas___"